export const ACCIDENT = {
  nickname: 'PRODUCTS.ACCIDENT.nickname',
  properties: [
    { name: 'coverageSumInsuredAccidentDeath', key: 'COVERAGE_SUM_INSURED_ACCIDENT_DEATH', group: 'INSURANCE_INFO' },
    { name: 'coverageSumInsuredAccidentInvalidity', key: 'COVERAGE_SUM_INSURED_ACCIDENT_INVALIDITY', group: 'INSURANCE_INFO' },
    { name: 'objectName', key: 'OBJECT_NAME', group: 'OBJECT_INFO' },
  ],
  lifeInsurance: true,
  icon:'accident'
};
